import {
	Component,
	ViewEncapsulation,
	Input,
	EventEmitter,
	Output
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { SideNavItem } from "../sidenav/sidenav.interface";
import { TopNavItem } from "../topnav/topnav.interface";

@Component({
	selector: "rbc-layout",
	templateUrl: "./layout.component.html",
	encapsulation: ViewEncapsulation.None
})
export class LayoutComponent {
	@Input() id;
	@Input() sideNav: SideNavItem[];
	@Input() topNav: TopNavItem[];
	@Input() logo: string;
	@Input() logoLink: string;
	@Input() logoLabel: string;
	@Input() fullWidth;
	@Input() currentPage: Object;
	@Input() search: Function | boolean;
	@Input() searchPlaceholder;
	@Input() sideNavArrows;
	@Input() toggleType: string;
	@Input() anchorLinks: [];
	@Input() logoRouter: string;
	@Input() showSecondary;
	@Input() toggled: boolean;
	@Output() navToggleUpdate = new EventEmitter();

	sideNavOpenedContentDisabled = false;

	constructor(
		private idService: IdService
	) {
		this.id = idService.generate();
	}

	$_Layout_sorted(el) {
		if (el) {
			let routesWithOrder = el.filter(
				cell => typeof cell.meta !== "undefined" && typeof cell.meta.order !== "undefined"
			);
			let routesWithoutOrder = el.filter(
				cell => typeof cell.meta === "undefined" || typeof cell.meta.order === "undefined"
			);
			routesWithOrder = routesWithOrder.sort((a, b) => {
				if (a.meta.order < b.meta.order) { return -1; }
				if (a.meta.order > b.meta.order) { return 1; }
				return 0;
			});
			routesWithoutOrder = routesWithoutOrder.sort((a, b) => {
				if (a.name < b.name) { return -1; }
				if (a.name > b.name) { return 1; }
				return 0;
			});
			return routesWithOrder.concat(routesWithoutOrder);
		}
	}

	$_Layout_updateContentDisabled(e) {
		this.navToggleUpdate.emit(e);
		if (this.isMd) {
			this.sideNavOpenedContentDisabled = e;
		}
	}

	get isMd() {
		if (typeof window !== "undefined" && typeof window.matchMedia !== "undefined") {
			return window.matchMedia("(max-width: 991px)").matches;
		} else {
			return false;
		}
	}
}
